import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const filter = {
	VerifiedStatus: null as Number | null,
	SubCategoryStatus: null as Number | null,
};

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VerifiedStatus: [],
		SubCategoryStatus: [],
	},
	filter,
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
